import { render, staticRenderFns } from "./MapImgFallback.vue?vue&type=template&id=5346e164&"
import script from "./MapImgFallback.vue?vue&type=script&lang=js&"
export * from "./MapImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5346e164')) {
      api.createRecord('5346e164', component.options)
    } else {
      api.reload('5346e164', component.options)
    }
    module.hot.accept("./MapImgFallback.vue?vue&type=template&id=5346e164&", function () {
      api.rerender('5346e164', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2pT7KU8qxtdVr/JS/comp/MapImgFallback.vue"
export default component.exports